import classNames from "classnames";
import styles from "./style.module.scss";
import ReactChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";

interface CustomChartProps<T = string | number> {
  data: {
    x: T[];
    y: number[];
  };
  type?: "line" | "bar" | "area" | "pie" | "donut" | "scatter";
  yAxisLabel?: string;
  seriesName?: string;
  curveStyle?: "smooth" | "straight" | "stepline";
}

const CustomChart = <T extends string | number>({
  data,
  type = "line",
  yAxisLabel = "Y-Axis",
  seriesName = "Series 1",
  curveStyle = "smooth",
}: CustomChartProps<T>) => {
  const chartData = {
    series: [
      {
        name: seriesName,
        data: data.y,
      },
    ],
    options: {
      chart: {
        id: "custom-chart",
        toolbar: { show: false },
      },
      xaxis: {
        categories: data.x,
      },
      yaxis: {
        title: {
          text: yAxisLabel,
        },
      },
      stroke: {
        curve: curveStyle,
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 5,
      },
      tooltip: {
        enabled: true,
      },
    } as ApexOptions,
  };

  return (
    <div className={classNames(styles.chartContainer)}>
      <ReactChart
        options={chartData.options}
        series={chartData.series}
        type={type}
        height="100%"
      />
    </div>
  );
};

export default CustomChart;
